import ReportsForm from 'src/javascripts/components/reports/ReportsForm';

export default class ReportsEdit {

  constructor() {}

  render() {

    ReportsForm();

  }

}
